import {FC, useState} from 'react';
import {IRecordStructurePromptParts} from '@kcast-fe/core';
import {Box, Flex} from '@chakra-ui/react';
import {HorizontalTabs, IHorizontalTab} from 'ui-kit';

import {CandidatesTable, PartRow} from './components';

interface IProps {
  parts: IRecordStructurePromptParts;
}

type TBottomTab = 'search-candidates' | 'memory';

export const PromptParts: FC<IProps> = ({parts}) => {
  const [selectedTab, setSelectedTab] = useState<TBottomTab>('search-candidates');

  const tabs: IHorizontalTab[] = [
    {
      id: 'search-candidates',
      label: 'Search candidates',
      count: parts.search_candidates?.length ?? 0
    },
    {id: 'memory', label: 'Memory'}
  ];

  return (
    <Flex pt={'12px'} flexDirection={'column'} gap={'16px'}>
      <PartRow label={'Date'} value={parts.datetime} />
      <PartRow label={'User preferences'} value={parts.user_preferences} />
      <PartRow label={'User system refiner'} value={parts.user_system_refiner} />
      <PartRow label={'MCP knowledge'} value={parts.mcp_knowledge} />
      <PartRow label={'Reformulated query'} value={parts.reformulated_query} />
      <PartRow label={'Search result'} value={parts.search_result} />
      <PartRow label={'Vision notice'} value={parts.vision_notice} />
      <PartRow label={'Summary'} value={parts.summary} />
      <PartRow label={'Tool failures'} value={parts.tool_failures} />
      <PartRow label={'Node errors'} value={parts.node_errors} />
      <PartRow label={'Latest heart rate'} value={parts.latest_heart_rate} />
      <PartRow label={'Latest location'} value={parts.latest_location} />

      <Flex flexDirection={'column'} gap={'12px'}>
        <Box position={'sticky'} top={0} zIndex={1} bg={'{colors.white}'}>
          <HorizontalTabs
            tabs={tabs}
            selectedId={selectedTab}
            onSelect={(id) => setSelectedTab(id as TBottomTab)}
          />
        </Box>

        {selectedTab === 'search-candidates' && (
          <Box>
            <CandidatesTable docs={parts.search_candidates} />
          </Box>
        )}

        {selectedTab === 'memory' && (
          <>
            <PartRow label={'Memory'} value={parts.memory} />
            <PartRow label={'Message memories'} value={parts.message_memories} />
            <PartRow label={'Memory notes capacity'} value={parts.memory_notes_capacity} />
            <PartRow label={'Memory notes'} value={parts.memory_notes} />
          </>
        )}
      </Flex>
    </Flex>
  );
};
